import { ApplicationConfig } from '@angular/core';
import { provideCore } from './core/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app-routes';
import { provideMarkdown } from 'ngx-markdown';
import { provideToastr } from 'ngx-toastr';
/**
 * Application configuration
 * @see https://angular.io/api/core/ApplicationConfig
 */
export const appConfig: ApplicationConfig = {
    providers: [
        provideCore(),
        provideHttpClient(withInterceptorsFromDi()),
        provideToastr({
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            newestOnTop: true
        }),
        provideAnimations(),
        provideMarkdown(),
        provideRouter(appRoutes),
    ],
};
